$.lui("comp", ".comp_visual", function(selector) {
    if (selector[0].querySelector(`[data-click="scrollNext"]`) !== null) {
        selector[0].querySelector(`[data-click="scrollNext"]`).addEventListener("click", () => {
            locomotive.scrollTo(selector.next()[0]);
        });
    }
});